import { motion } from 'framer-motion';

const ease = [0.16, 1, 0.3, 1];

export default function LuxReveal({
  children,
  delay = 0,
  y = 36,
  x = 0,
  className = '',
  once = true,
}) {
  return (
    <motion.div
      className={className}
      initial={{ opacity: 0, y, x }}
      whileInView={{ opacity: 1, y: 0, x: 0 }}
      viewport={{ once, margin: '-60px' }}
      transition={{ duration: 0.75, delay, ease }}
    >
      {children}
    </motion.div>
  );
}
